module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanning),
      expression: "scanning"
    }],
    staticClass: "QRScanner-lock",
    on: {
      "click": _vm.closeScanner
    }
  }, [_vm._v("......")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanning),
      expression: "scanning"
    }],
    staticClass: "QRScanner-container"
  }, [_c('label', {
    staticClass: "modal-close",
    attrs: {
      "for": "modal-toggle"
    },
    on: {
      "click": _vm.closeScanner
    }
  }, [_vm._v("✕")]), _vm._v(" "), _c('el-steps', {
    staticClass: "steps",
    attrs: {
      "active": _vm.active,
      "align-center": "",
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Instructions"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Scan QR-Code"
    }
  })], 1), _vm._v(" "), (_vm.active == 1) ? _c('div', {
    staticClass: "instructions-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.active == 1) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Scan")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 2),
      expression: "active == 2"
    }],
    staticClass: "camera-wrapper"
  }, [_c('el-select', {
    staticClass: "select-camera",
    attrs: {
      "placeholder": "Choose a camera"
    },
    model: {
      value: (_vm.cameraIndex),
      callback: function($$v) {
        _vm.cameraIndex = $$v
      },
      expression: "cameraIndex"
    }
  }, _vm._l((_vm.cameras), function(camera, index) {
    return _c('el-option', {
      key: camera.id,
      attrs: {
        "label": _vm.formatName(camera.name, index),
        "value": index
      }
    })
  }), 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.noQR
    }
  }, [_vm._v("I don't have a camera")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("Just two quick steps!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instructions"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/QR.png")
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Locate the "), _c('b', [_vm._v("QR-Code")]), _vm._v(" on your ninja")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Scan")]), _vm._v(" button to scan ninja")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "scanner-wrapper"
    }
  }, [_c('video', {
    attrs: {
      "id": "scanner"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33081ac0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scan.vue
// module id = 1171
// module chunks = 12